/**
 * Backwards-compatible redirect: `/website-users/:userId` → `/users/website/:userId`.
 * Keeps bookmarks and emailed links to a website user's profile alive.
 */
import { Navigate, useParams } from "react-router-dom";
import { ROUTES } from "@/routes";

export default function WebsiteUserRedirect() {
  const { userId } = useParams<{ userId: string }>();
  return (
    <Navigate to={userId ? ROUTES.users.websiteDetail(userId) : ROUTES.users.website} replace />
  );
}
